var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.43 186.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n        stroke: #fbeeee;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.3px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke: #231f20;\n      }\n\n      .cls-3 {\n        fill: #fbeeee;\n      }\n\n      .cls-4 {\n        fill: #fbb03b;\n      }\n\n      .cls-6 {\n        fill: #78b7de;\n      }\n\n      .cls-5 {\n        fill: #fb7676;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.43,34.86c2.12.52,5.32-.25,4.8-2.78-.24-1.16-1.9-1.73-2.83-2.24-1.02-.55-1.81-1.12-2.57-1.99-1.98-2.24-3.5-4.83-4.63-7.58-2.42-5.85-5.73-10.24-11.14-13.56-4.58-2.81-9.47-3.99-14.71-4.92-6.44-1.14-12.84-1.48-19.4-.81-6.1.62-12.89,1.93-18.09,5.29-2.99,1.94-5.36,4.12-6.97,7.31-.7,1.38-1.26,2.79-1.88,4.21-.75,1.71-5.78,8.99-6.27,9.64-1.14,1.49-4.14,2.58-2.87,4.52,2.02,3.1,6.1-1.21,7.41-3.07,3.05-4.35,5.65-9.07,8.16-13.74,2.26-4.21,7.72-7.64,12.29-8.64,3.93-.85,8.28-1.19,12.28-1.02s7.95.41,11.95.95c2.4.32,4.71.97,7.09,1.37,2.56.44,4.94.86,7.32,2,3.44,1.65,5.84,3.64,7.97,6.86,1.94,2.94,3.61,6.05,5.23,9.17,1.45,2.79,3.13,6.51,5.68,8.48.31.24.73.42,1.21.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.45,36.87c-.59-.28-1.02-1.4-1.36-1.94-.49-.76-.89-1.57-1.23-2.4-.51-1.24-.79-2.65-.61-4,.19-1.43,1.42-2.2,2.81-2.25,1.17-.04,2.2.92,3.04,1.68,1.52,1.36,3.78,4.39,3.03,6.66-.7,2.12-3.39,2.7-5.3,2.56.16-.08.32-.1-.38-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.45,34.66c.98-3.05,2.67-7.28,6.32-7.85,1.84-.29,3.18.78,3.58,2.54.35,1.54-.24,3.03-.89,4.43-.88,1.9-3.23,4.4-5.43,4.5-.99.05-4.61-1.9-3.58-3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.61,59.27c.55-1.65,1.8-3.11,2.76-4.54.67-1.01,1.38-2,2.1-2.98s1.63-2.25,3.03-2.15c.64.05,1.75.22,2.09.8s.07,1.36-.13,1.9c-.37,1.03-.75,2.14-1.31,3.09-1.23,2.08-2.69,6.33-5.37,6.83-1.1.21-2.26-.27-2.86-1.21-.22-.34-.8-1.44-.31-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.98,52.64c-1.03-1.93-1.56-4.38.71-5.66,1.22-.69,2.49-.26,3.29.77,1.76,2.27,3.27,5.06,4.68,7.56,1.06,1.89,2.2,3.35.86,5.38-.44.67-2.93,1.27-3.71,1.46-.24.06-4.12-6.31-5.83-9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.26,185.4c-1.3-2.1-3.98-3.93-5.76-5.63-1.44-1.37-2.69-2.89-3.96-4.44-1.62-1.99-3.5-4.94-3.28-7.63.16-2.05,3.11-3.99,4.82-2.35,2.11,2.02,3.85,4.92,5.31,7.44,1.65,2.83,3.51,5.62,4.84,8.59.39.86.98,2.12.79,3.09-.31,1.57-1.95.58-2.76.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.68,184.38c-.47-1.98,1.37-5.1,2.24-6.85.96-1.92,2.08-3.79,3.2-5.63,1.4-2.3,4.14-7.5,7.42-6.93,1.75.3,2.48,2.27,2.58,3.84.09,1.34-.38,2.14-1.12,3.24-2.21,3.28-4.56,6.27-7.07,9.37-.97,1.2-4.93,5.98-7.26,2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.86,49.25C31.65,49.25,2.3,78.65,2.3,114.92s29.35,65.67,65.56,65.67,65.55-29.4,65.55-65.67-29.35-65.67-65.55-65.67ZM67.94,168.3c-29.64,0-53.66-24.14-53.66-53.92s24.02-53.93,53.66-53.93,53.66,24.14,53.66,53.93-24.02,53.92-53.66,53.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.6,114.38c0,29.78-24.02,53.92-53.66,53.92s-53.66-24.14-53.66-53.92,24.02-53.93,53.66-53.93,53.66,24.14,53.66,53.93Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 67.9,
    cy: 114.75,
    r: 40.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 67.9,
    cy: 114.75,
    r: 2.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M.67,53.67c-.27-3.81,1.95-7.4,4.62-10.14,5.2-5.34,12.97-8.3,19.53-11.39,3.44-1.62,6.88-3.39,10.51-4.51,6.5-2.02,13.31-.25,16.71,6.22,1.27,2.42.19,4.16-1.77,5.44-5.16,3.39-29.78,16.5-36.82,19.97-2.73,1.34-6.48,3.73-9.65,2.85-.15.1-2.72-2.58-3.13-8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.33,36.4c.49-3.89,5.21-7.23,8.75-8.09,4.67-1.14,9.14-.16,13.46,1.79,5,2.26,9.57,5.25,14.35,7.89,3.34,1.85,6.44,3.93,9.56,6.09,1.19.82,2.37,1.68,3.4,2.68,1.6,1.55,2.1,3.29,2.58,5.45s.48,4.17.07,6.29c-.26,1.36-.83,4.12-1.81,5.12-.71.71-2.24.34-3.18.15-2.97-.6-5.37-2.14-8.1-3.35-4.79-2.14-9.34-4.6-13.94-7.15-3.27-1.81-6.37-3.86-9.71-5.55s-6.59-3.52-9.84-5.48c-2.44-1.47-5.28-2.75-5.57-5.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.63,
    cy: 68.2,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.36,
    cy: 74.44,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 27.32,
    cy: 91.48,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21.08,
    cy: 114.75,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 27.32,
    cy: 138.03,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.36,
    cy: 155.07,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.63,
    cy: 161.31,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.91,
    cy: 155.07,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 107.95,
    cy: 138.03,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.18,
    cy: 114.75,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 107.95,
    cy: 91.48,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.91,
    cy: 74.44,
    r: 1.69
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHour);
export default __webpack_public_path__ + "static/media/hour.4c22eef5c755317a850956f4d49bab1e.svg";
export { ForwardRef as ReactComponent };